export enum SexName {
  SKINS = "SKINS",
}
